import Icon from '../components/Icon.vue'

Icon.register({"music":{"width":512,"height":512,"paths":[{"d":"M470.4 1.5L166.4 97.5C153.1 101.7 144 114 144 128V392.6C129.9 387.2 113.5 384 96 384 43 384 0 412.7 0 448S43 512 96 512 192 483.3 192 448V220.5L464 134.6V328.6C449.9 323.2 433.5 320 416 320 363 320 320 348.7 320 384S363 448 416 448 512 419.3 512 384V32C512 10.3 490.9-5 470.4 1.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/music.js
// module id = null
// module chunks = 